import { IIconProps } from "@fluentui/react";
import { ErrorType } from "../../../models/HttpError";

// stores
import * as SettlementStore from '../../../redux/middleware/SettlementMiddleware';
import * as SponsorStore from '../../../redux/middleware/SponsorMiddleware';
import * as PractitionerStore from '../../../redux/middleware/PractitionerMiddleware';
import * as MedicalInsuranceStore from '../../../redux/middleware/MedicalInsuranceMiddleware';
import * as MedicalProtocolStore from '../../../redux/middleware/MedicalProtocolMiddleware';
import * as CashFlowDebtsStore from '../../../redux/middleware/CashFlow-Debts.Middleware';
import * as jwt_decode from "jwt-decode";

//State
import { AppState } from "../../../redux/reducers";
import { Settlement } from "../../../models/Entities/Settlements/Settlement";
import { Sponsor } from "../../../models/Entities/Sponsor/Sponsor";
import { Practitioner } from "../../../models/Entities/Practitioners/Practitioner";
import { MedicalInsurance } from "../../../models/Entities/MedicalInsurances/MedicalInsurance";
import { Protocol } from "../../../models/Entities/Protocols/Protocol";


interface IProps {
  ContractId?: number | undefined;
  PractitionerId?: string | undefined;
  ProtocolId?: number | undefined;
  SponsorId?: number | undefined;
  MedicalInsuranceId?: number | undefined;
  MedicalAgreementId?: number | undefined;
}

  interface ConnectedProps {
    isLoading: boolean;
    isLoadingSuccessfully: boolean;
    failOnLoading: boolean;
    isDeleting: boolean;
    error: ErrorType | undefined;
    Settlements: Settlement[];
    sponsorList: Sponsor[] | undefined;
    practitionerList: Practitioner[] | undefined;
    medicalInsuranceList: MedicalInsurance[] | undefined;
    protocolList: Protocol[] | undefined;
    /** Identificador del centro (tenant): decide si las deudas se cobran o se pagan. */
    OwnerId: string;
  }

  interface SettlementDispatchProps {
    GetAllSettlements: typeof SettlementStore.actionCreators.GetAllSettlements;
    RefreshSettlementById: typeof SettlementStore.actionCreators.RefreshSettlementById;
    DeleteSettlementById: typeof SettlementStore.actionCreators.DeleteSettlementById;
    GetSponsorById: typeof SponsorStore.actionCreators.GetSponsorById;
    GetPractitionerById: typeof PractitionerStore.actionCreators.GetPractitionerById;
    GetMedicalInsuranceById: typeof MedicalInsuranceStore.actionCreators.GetMedicalInsuranceById;
    GetAllMedicalProtocols: typeof MedicalProtocolStore.actionCreators.GetAllMedicalProtocols;
    /** Trae las deudas de cashflow de una liquidación (montos y saldos) al store de la liquidación. */
    GetDebtsBySettlementId: typeof CashFlowDebtsStore.actionCreators.GetDebtsBySettlementId;
  }

  export type Props = IProps & ConnectedProps & SettlementDispatchProps;

  export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    isLoading: state.Settlement?.isLoadingAll || false,
    isLoadingSuccessfully: state.Settlement?.successLoadingAll || false,
    failOnLoading: state.Settlement?.failOnLoadingAll || false,
    isDeleting: state.Settlement?.isDeletingOne || false,
    error: state.Settlement?.error,
    Settlements: (state.Settlement?.list || []).filter((settlement: Settlement) =>
    ownProps.ContractId ? settlement.contract?.some((contract) => contract.contractId === ownProps.ContractId) :
    ownProps.MedicalAgreementId ? settlement.agreements?.some((agreement) => agreement.medicalAgreementId === ownProps.MedicalAgreementId) :
    ownProps.PractitionerId ? settlement.practitioner?.some((practitioner) => practitioner.practitionerId === ownProps.PractitionerId) :
    ownProps.ProtocolId ? settlement.protocol?.some((protocol) => protocol.protocolId === ownProps.ProtocolId) :
    ownProps.SponsorId ? settlement.sponsor?.some((sponsor) => sponsor.sponsorId === ownProps.SponsorId) : true ).sort((a, b) => b.id - a.id),
    sponsorList: state.Sponsor?.list,
    practitionerList: state.Practitioners?.list,
    medicalInsuranceList: state.MedicalInsurances?.list,
    protocolList: state.MedicalProtocols?.list,
    OwnerId: state?.oidc?.user?.access_token
        ? ((jwt_decode.jwtDecode(state.oidc.user.access_token) as { tenantId?: string })?.tenantId ?? '')
        : '',
  });

  export const mapDispatchToProps = {
    GetAllSettlements: SettlementStore.actionCreators.GetAllSettlements,
    RefreshSettlementById: SettlementStore.actionCreators.RefreshSettlementById,
    DeleteSettlementById: SettlementStore.actionCreators.DeleteSettlementById,
    GetSponsorById: SponsorStore.actionCreators.GetSponsorById,
    GetPractitionerById: PractitionerStore.actionCreators.GetPractitionerById,
    GetMedicalInsuranceById: MedicalInsuranceStore.actionCreators.GetMedicalInsuranceById,
    GetAllMedicalProtocols: MedicalProtocolStore.actionCreators.GetAllMedicalProtocols,
    GetDebtsBySettlementId: CashFlowDebtsStore.actionCreators.GetDebtsBySettlementId,
  };


  //#region Icons
export const PropertiesIcon: IIconProps = { iconName: 'DietPlanNotebook' };
export const AddIcon: IIconProps = { iconName: 'CirclePlus' };
export const ViewIcon: IIconProps = { iconName: 'View' };
export const LinkContractIcon: IIconProps = { iconName: 'Link' };
export const RefreshIcon: IIconProps = { iconName: 'SyncOccurence' };

//#endregion

export const GetSettlementStatusDescripcion = (status: number | undefined) => {
    switch (status) {
      case undefined:
          return 'SettlementStatus.pending'; // "Pendiente";
        case 1:
            return 'SettlementStatus.registered'; // "Registrado";
        case 2:
            return 'SettlementStatus.inProcess'; // "En proceso";
        case 3:
            return 'SettlementStatus.finished'; // "Finalizado";
        case 4:
            return 'SettlementStatus.cancelled'; // "Cancelado";
        case 5:
            return 'SettlementStatus.Confirmed'; // "Conformado";
        case 6:
            return 'SettlementStatus.rejected'; // "Rechazado";
        case 7:
            return 'SettlementStatus.fail'; // "Fallido";
        case 8:
            return 'SettlementStatus.paid'; // "Pagado";
        case 9:
            return 'SettlementStatus.debtUnpaid'; // "Deuda impaga";
        default:
        return 'SettlementStatus.pending'; // "Pendiente";
    }
  };

export const GetSettlementStatusClass = (status: number | undefined) => {
    switch (status) {
        case undefined:
            return "";
        case 1:
            return "gray";
        case 2:
            return "blue";
        case 3:
            return "green";
        case 4:
            return "red";
        case 5:
            return "teal";
        case 6:
            return "red";
        case 7:
            return "black";
        case 8:
            return "indigo";
        case 9:
            return "orange";
        default:
        return "gray";
  }
};

export const GetSettlementStatusIcon = (status: number | undefined) => {
    switch (status) {
        case undefined:
            return 'WaitlistConfirmMirrored';
        case 1:
            return 'WaitlistConfirmMirrored';
        case 2:
            return 'SyncStatus';
        case 3:
            return 'SkypeCircleCheck';
        case 4:
            return 'StatusErrorFull';
        case 5:
            return 'Completed';
        case 6:
            return 'StatusErrorFull';
        case 7:
            return 'ErrorBadge';
        case 8:
            return 'PaymentCard';
        case 9:
            return 'Warning';
        default:
        return 'WaitlistConfirmMirrored';
    }
  }
